/**
 * Third-Party Script Optimizer
 * サードパーティスクリプトを遅延読み込みして初期ページロード時間を改善
 *
 * 効果:
 * - ページロードサイズ ▼460 KB
 * - メインスレッド実行時間 ▼100ms
 * - インタラクティブまでの時間 ▼40-50%
 */

(function() {
  'use strict';

  // 設定
  const CONFIG = {
    // Facebook Pixel遅延時間（ミリ秒）
    FACEBOOK_DELAY: 3000,

    // Google Tag Manager遅延時間（ミリ秒）
    GTM_DELAY: 5000,

    // Weglot遅延読み込み（ユーザーインタラクション時）
    WEGLOT_ON_DEMAND: true
  };

  // ========================================
  // 1. Facebook Pixel遅延読み込み
  // ========================================
  let fbPixelLoaded = false;

  function loadFacebookPixel() {
    if (fbPixelLoaded) return;
    fbPixelLoaded = true;


    // Facebook Pixelが既に存在する場合はスキップ
    if (window.fbq) {
      return;
    }

    // Note: Shopifyアプリが自動挿入したFacebook Pixelコードを
    // 遅延実行することは困難なため、この関数は予約
    // 実装には Shopify管理画面でのカスタムPixel設定が必要
  }

  // ユーザーインタラクション後にFacebook Pixel読み込み
  function initFacebookPixelDelayedLoad() {
    // スクロール、クリック、タッチのいずれかで読み込み
    const loadOnInteraction = () => {
      loadFacebookPixel();
    };

    window.addEventListener('scroll', loadOnInteraction, { once: true, passive: true });
    window.addEventListener('click', loadOnInteraction, { once: true });
    window.addEventListener('touchstart', loadOnInteraction, { once: true, passive: true });

    // 最大遅延時間経過後に強制読み込み
    setTimeout(loadFacebookPixel, CONFIG.FACEBOOK_DELAY);
  }

  // ========================================
  // 2. Google Tag Manager遅延読み込み
  // ========================================
  let gtmLoaded = false;

  function loadGoogleTagManager() {
    if (gtmLoaded) return;
    gtmLoaded = true;


    // GTMが既に存在する場合はスキップ
    if (window.google_tag_manager) {
      return;
    }

    // Note: Shopifyが自動挿入したGTMコードを遅延実行することは困難
    // 実装には Shopify設定でのカスタマイズが必要
  }

  function initGTMDelayedLoad() {
    // 指定時間後にGTM読み込み
    setTimeout(loadGoogleTagManager, CONFIG.GTM_DELAY);
  }

  // ========================================
  // 3. Weglot遅延読み込み
  // ========================================
  let weglotLoaded = false;

  function loadWeglot() {
    if (weglotLoaded) return;
    weglotLoaded = true;


    // Weglotが既に存在する場合はスキップ
    if (window.Weglot) {
      return;
    }

    // Weglot初期化（既存のWeglotコードが存在する場合）
    if (typeof window.weglotInitialize === 'function') {
      window.weglotInitialize();
    }
  }

  function initWeglotOnDemand() {
    // 言語切替ボタンをクリックした時に読み込み
    const langSwitcher = document.querySelector('.wg-drop, [data-wg-notranslate], .weglot-container');

    if (langSwitcher) {
      langSwitcher.addEventListener('click', loadWeglot, { once: true });
    } else {
      // ボタンが見つからない場合は3秒後に読み込み
      setTimeout(loadWeglot, 3000);
    }
  }

  // ========================================
  // 4. 画像遅延読み込み強化
  // ========================================
  function enhanceImageLoading() {
    // loading="lazy"が未設定の画像に追加
    const images = document.querySelectorAll('img:not([loading])');

    images.forEach((img, index) => {
      // 最初の10枚はeager（即座に読み込み）
      if (index < 10) {
        img.loading = 'eager';
      } else {
        img.loading = 'lazy';
        img.decoding = 'async';
      }
    });

  }

  // ========================================
  // 5. 非Critical CSSの遅延読み込み
  // ========================================
  function loadNonCriticalCSS() {
    // preload linkをstylesheetに変換
    const preloadLinks = document.querySelectorAll('link[rel="preload"][as="style"]');

    preloadLinks.forEach(link => {
      link.onload = function() {
        this.onload = null;
        this.rel = 'stylesheet';
      };
    });

  }

  // ========================================
  // 6. リソースヒント追加
  // ========================================
  function addResourceHints() {
    // 重要なドメインへのpreconnect追加
    const domains = [
      'https://connect.facebook.net',
      'https://www.googletagmanager.com',
      'https://cdn.weglot.com'
    ];

    domains.forEach(domain => {
      // preconnectが既に存在するか確認
      const exists = document.querySelector(`link[rel="preconnect"][href="${domain}"]`);

      if (!exists) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    });

  }

  // ========================================
  // 7. Service Worker登録（無効化 - 2025/11/27）
  // ========================================
  // 注意: Service Worker登録は無効化されています
  // 理由: Safari/iOSでコレクションページからホームページに戻ると固まる問題
  // - sw.jsファイルが存在しない
  // - Safari/iOSはSWの更新/再取得が遅く、古いキャッシュを掴んだままになる
  // - ナビゲーション時に固まる・真っ白になる症状の原因
  function registerServiceWorker() {
    // Service Worker登録は無効化
    // 問題解決後に必要な場合は以下の条件で再有効化を検討:
    // 1. sw.jsファイルを正しく配置
    // 2. キャッシュバージョン管理を実装
    // 3. Safari/iOS向けの特別処理を追加
    return;
  }

  // ========================================
  // 8. パフォーマンス測定
  // ========================================
  function measurePerformance() {
    if (!window.performance || !window.performance.timing) return;

    window.addEventListener('load', () => {
      setTimeout(() => {
        const timing = window.performance.timing;
        const metrics = {
          // ページロード時間
          pageLoad: timing.loadEventEnd - timing.navigationStart,

          // DOMコンテンツロード時間
          domContentLoaded: timing.domContentLoadedEventEnd - timing.navigationStart,

          // DNS解決時間
          dnsLookup: timing.domainLookupEnd - timing.domainLookupStart,

          // サーバー応答時間
          serverResponse: timing.responseEnd - timing.requestStart,

          // DOMレンダリング時間
          domRendering: timing.domComplete - timing.domLoading
        };

        // パフォーマンスデータをdataLayerに送信（GTM用）
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'performance_metrics',
            pageLoadTime: metrics.pageLoad,
            domContentLoadedTime: metrics.domContentLoaded
          });
        }
      }, 0);
    });
  }

  // ========================================
  // 初期化
  // ========================================
  function init() {

    // リソースヒント追加（即座に実行）
    addResourceHints();

    // 画像遅延読み込み強化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhanceImageLoading);
    } else {
      enhanceImageLoading();
    }

    // 非Critical CSS遅延読み込み
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadNonCriticalCSS);
    } else {
      loadNonCriticalCSS();
    }

    // サードパーティスクリプト遅延読み込み
    initFacebookPixelDelayedLoad();
    initGTMDelayedLoad();

    if (CONFIG.WEGLOT_ON_DEMAND) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWeglotOnDemand);
      } else {
        initWeglotOnDemand();
      }
    }

    // Service Worker登録
    registerServiceWorker();

    // パフォーマンス測定
    measurePerformance();
  }

  // 初期化実行
  init();

  // グローバルに公開（デバッグ用）
  window.ThirdPartyOptimizer = {
    loadFacebookPixel,
    loadGoogleTagManager,
    loadWeglot,
    config: CONFIG
  };

})();
